import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.esm.browser.min.js';

document.addEventListener('DOMContentLoaded', () => {
    const SHIPPING_THRESHOLD = 50;
    const RECOMMENDATIONS_LIMIT = 10;
    const APPROACHING_THRESHOLD = 40;
    const POLLING_RATE = 500;
    const SWIPER_POLLING_RATE = 10;

    let isInstancesEnabled = false;
    let currentPrice = undefined;
    let swiperCount = 0

    let isCheckingPrice = false;
    let isCheckingSwiperInstance = false;

    disableInstance();
 $(document).ready(function () {
        $(document).on("click", "button", function (event) {
         startPriceCheck();
          startSwiperInstanceCheck();
        });
    });
   // setInterval(startPriceCheck, POLLING_RATE);

   // setInterval(startSwiperInstanceCheck, SWIPER_POLLING_RATE);

    function startPriceCheck() {
        if (isCheckingPrice)
            return;

        isCheckingPrice = true;

        checkPrice().then(() => {
            const swiperContainers = document.querySelectorAll('.shipping-recommendations__container');

            // if (isInstancesEnabled && swiperCount !== swiperContainers.length)
            //     initializeSwipers();

            isCheckingPrice = false;
        });
    }

    function startSwiperInstanceCheck() {
        if (isCheckingSwiperInstance)
            return;

        isCheckingSwiperInstance = true;

        const swiperContainers = document.querySelectorAll('.shipping-recommendations__container');

        if (swiperCount !== swiperContainers.length)
            initializeSwipers();

        isCheckingSwiperInstance = false;
    }

    async function checkPrice() {
        await fetch('/cart.js')
            .then(response => response.json())
            .then(async data => {
                let dataPrice = data.total_price;

                // If the price has changed or the price is 0 and the current price is not 0
                if ((dataPrice && dataPrice !== (currentPrice * 100)) || (dataPrice === 0 && currentPrice !== 0)) {
                    currentPrice = dataPrice / 100;
                    setProgress();
                    await getRecommendations(data);

                    enableInstance();
                }
            })
            .catch(error => {
                console.error("Error checkout cart price: ", error);
                disableInstance();
            });
    }

    function setProgress() {
        const progressBar = document.querySelectorAll('.progress-bar__fill');
        const progressText = document.querySelectorAll('.progress-text');

        let copy = "Free shipping for orders over $50.00!";
        let percent = 0;

        if (currentPrice >= SHIPPING_THRESHOLD) {
            copy = "You have free shipping!";
            percent = 100;
        }

        else if (currentPrice > 0) {
            const shippingThresholdDifference = (SHIPPING_THRESHOLD - currentPrice).toFixed(2);

            percent = (currentPrice / SHIPPING_THRESHOLD) * 100;
            copy = percent >= APPROACHING_THRESHOLD ?
                `Almost there! Just spend $${ shippingThresholdDifference}  more to get free shipping.`:
                `Spend $${ shippingThresholdDifference}  more to get free shipping!`;
        }

        progressBar.forEach(bar => bar.style.width = `${ percent }%`);
        progressText.forEach(text => text.innerHTML = copy);
    }

    async function getRecommendations(cartData) {
        if (!cartData?.items?.[0])
            return disableRecommendations();

        // TODO: Recommend products based on all items in cart
        // cartData.items.map(item => item.product_id).join(',')
        // The above line will return a comma separated list of product IDs
        // Use this list to get recommendations for all items in the cart
        // Then mix the recommendations together and remove duplicates

        const url = new URL('recommendations/products.json', window.location.origin);
        url.searchParams.set('product_id', cartData.items[0].product_id);
        url.searchParams.set('limit', RECOMMENDATIONS_LIMIT.toString());
        url.searchParams.set('intent', 'related');

        fetch(url.href)
            .then(response => response.json())
            .then(data => {
                if (!data.products)
                    return disableRecommendations();

                renderRecommendations(data.products);
            })
            .catch(error => {
                console.error("Error retrieving product recommendations ", error);

                disableRecommendations();
            });
    }

    function renderRecommendations(products) {
        const containers = document.querySelectorAll('.shipping-recommendations__container .swiper-wrapper');

        const productList = [];

        products.forEach(product => {
            // Create product container
            const productContainer = document.createElement('a');
            productContainer.href = product.url;
            productContainer.classList.add('swiper-slide');

            // Create product image
            const productImageContainer = document.createElement('div');
            productImageContainer.classList.add('shipping-recommendations__image-container');

            const productImageIntrinsic = document.createElement('div');
            productImageIntrinsic.classList.add('shipping-recommendations__image-intrinsic');

            const productImage = document.createElement('img');
            productImage.classList.add('shipping-recommendations__image');
            productImage.alt = product.title;

            let productMedia = product.featured_image;

            // t.variants[0] : essentialFreeShippingGetVariant(e, t))?.featured_image?.src || t.featured_image,

            if (product.variants[0].featured_image)
                productMedia = product.variants[0].featured_image.src;

            // If the product has media select the last media item that is an image
            // if (product.media.length > 0 && product.media[product.media.length - 1].media_type === 'image')
            //     productMedia = product.media[product.media.length - 1].preview_image.src;
            //
            // else if (product.media.length > 1 && product.media[product.media.length - 2].media_type === 'image')
            //     productMedia = product.media[product.media.length - 2].preview_image.src;
            //
            // else if (product.media.length >= 2 && product.media[1].media_type === 'image')
            //     productMedia = product.media[1].preview_image.src;
            //
            // else if (product.media.length >= 1 && product.media[0].media_type === 'image')
            //     productMedia = product.media[0].preview_image.src;

            productImage.src = productMedia.replace(".jpg", "_800x.jpg").replace(".png", "_800x.png");

            productImageIntrinsic.appendChild(productImage);
            productImageContainer.appendChild(productImageIntrinsic);

            // Create product title
            const productTitle = document.createElement('h3');
            productTitle.classList.add('shipping-recommendations__title');
            productTitle.innerHTML = product.title;

            // Create product price
            const productPrice = document.createElement('p');
            productPrice.classList.add('shipping-recommendations__price');
            productPrice.innerHTML = `$${ (product.variants[0].price / 100).toFixed(2) }`;

            // Create add to cart button
            const addToCartButton = document.createElement('button');
            addToCartButton.setAttribute('data-id', product.variants[0].id);
            addToCartButton.classList.add('shipping-recommendations__button');
            addToCartButton.innerHTML = "Add to Cart";

            productContainer.appendChild(productImageContainer);
            productContainer.appendChild(productTitle);
            productContainer.appendChild(productPrice);
            productContainer.appendChild(addToCartButton);

            productList.push({
                element: productContainer,
                id: product.variants[0].id
            });
        });

        containers.forEach(container => {
            container.innerHTML = "";
            productList.forEach(product => {
                const productClone = product.element.cloneNode(true);

                productClone.addEventListener('click', (event) => {
                    console.log("Link clicked");
                });

                productClone.querySelector('.shipping-recommendations__button')
                    .addEventListener('click', (event) => addToCart(product.id, event));

                container.appendChild(productClone);
            });
        });

        initializeSwipers();

        enableRecommendations();
    }

    function disableRecommendations() {
        document.querySelectorAll('.dx-shipping__container').forEach(container => {
            container.classList.add("recommendations--disabled");
        });
    }

    function enableRecommendations() {
        document.querySelectorAll('.dx-shipping__container').forEach(container => {
            container.classList.remove("recommendations--disabled");
        });
    }

    function disableInstance() {
        isInstancesEnabled = false;
        document.querySelectorAll('.dx-shipping__container').forEach(container => {
            container.classList.add("disabled");
        });
    }

    function enableInstance() {
        isInstancesEnabled = true;
        document.querySelectorAll('.dx-shipping__container').forEach(container => {
            container.classList.remove("disabled");
        });
    }

    function initializeSwipers() {
        const dxShippingContainer = document.querySelectorAll('.dx-shipping__container');
        const swiperContainers = document.querySelectorAll('.shipping-recommendations__container');

        swiperCount = swiperContainers.length;

        swiperContainers.forEach((container, index) => {
            if (container.swiper) {
                container.swiper.destroy();
                container.swiper = null;
            }

            container.querySelectorAll('.shipping-recommendations__button').forEach(button => {
                button.addEventListener('click', (e) => {
                    addToCart(button.getAttribute('data-id'), e)
                });
            });

            try {
                new Swiper((container), {
                    direction: 'horizontal',
                    loop: true,
                    slidesPerView: 1,
                    // autoplay : {
                    //     delay: 10000,
                    // },
                    navigation: {
                        nextEl: dxShippingContainer[index].querySelector('.swiper__arrows-container .swiper__arrow.next'),
                        prevEl: dxShippingContainer[index].querySelector('.swiper__arrows-container .swiper__arrow.prev'),
                    },
                    breakpoints: {
                        475: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 4,
                        }
                    }
                });
            } catch (error) {
                console.error("Error initializing swiper ", error);
            }
        });
    }

    function addToCart(id, event) {
        event.preventDefault();
        event.stopPropagation();

        console.log("Add to cart clicked");

        const data = {
            items: [
                {
                    id: id,
                    quantity: 1
                }
            ]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(() => window.location.href = '/cart')
            .catch(error => {
                console.error("ERROR adding item to cart: ", error);
            });
    }
})
